import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgTrophyFilled = (props) => {
    const { color } = props;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 2a1 1 0 0 0 0 2h1v1H4a2 2 0 0 0-2 2v3a4 4 0 0 0 4 4h.341A6.008 6.008 0 0 0 11 17.917V20H7a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2h-4v-2.083A6.008 6.008 0 0 0 17.659 14H18a4 4 0 0 0 4-4V7a2 2 0 0 0-2-2h-2V4h1a1 1 0 1 0 0-2H5Zm15 8a2 2 0 0 1-2 2V7h2v3ZM6 12V7H4v3a2 2 0 0 0 2 2Zm6 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z", fill: color }));
};
export default factorySvgIcon(SvgTrophyFilled);
//# sourceMappingURL=SvgTrophyFilled.js.map